/* eslint-disable @typescript-eslint/naming-convention */
export enum FLAG_TICKET {
  // --- 26.06

  // Apply table divider for OCR Editor
  "FSHMS01-159" = "FSHMS01-159",
  // [Pipeline Configuration] Layout Pipeline Configuration - close (X) button behavior
  "FSH2410-3512" = "FSH2410-3512",
  // [Pipeline Configuration] Layout Pipeline Configuration - invalidate cached workflow detail after released pipeline
  "FSH2410-3513" = "FSH2410-3513",
  // [AI Pipeline] Access + Settings AI Pipeline Page (Classification) - Auto classification
  "FSH2410-3523" = "FSH2410-3523",
  // [AI Pipeline] Create new custom pipeline - Auto Classification
  "FSH2410-3526" = "FSH2410-3526",
  // [Workflows] Workflow dropdown and access workflow page
  "FSH2410-3793" = "FSH2410-3793",
  // [Auto Classification] Auto Classification - New class modal with General, Keyword, Template steps
  "FSH2410-3560" = "FSH2410-3560",
  // [Workflows] Display new merge pages grouping option in Configure Output - Classification
  "FSH2410-3602" = "FSH2410-3602",
  // [Editor] Classification Result - Display information icon tooltip when has highest class, matched keyword or low confidence score
  "FSH2410-3596" = "FSH2410-3596",
  // [Editor] OCR Editor - Initial auto focus behavior
  "FSH2410-4114" = "FSH2410-4114",
  // [Editor] OCR Editor - Enable keyboard shortcuts for editor actions
  "FSH2410-4115" = "FSH2410-4115",
}

export type FeatureFlagId = number;

export interface FeatureFlag {
  id: FeatureFlagId;
  ticket: FLAG_TICKET;
  description: string;
  enable: boolean;
}
